import { Card, Page, PageHeader } from "@/components/kit";
import { BASE } from "@/lib/api";

const API_EXAMPLE = `curl -X POST ${BASE}/provision \\
  -H "Content-Type: application/json" \\
  -H "X-Provision-Key: <PROVISION_API_KEY>" \\
  -d '{
    "name": "Cantina Bella",
    "slug": "cantina-bella",
    "admin_name": "Marco",
    "admin_email": "marco@cantinabella.com",
    "status": "teste",
    "trial_days": 14,
    "cmv_target": 32,
    "plan_id": null,
    "domains": [],
    "brand": { "app_name": "Cantina Bella · CMV", "brand": "#8B2E1F", "accent": "#D9A441", "logo_url": "" }
  }'`;

const CLI_EXAMPLE = `cd backend
python cli.py create-tenant --name "Cantina Bella" --slug cantina-bella \\
  --admin-name Marco --admin-email marco@cantinabella.com \\
  --cmv-target 32 --brand-color "#8B2E1F" --app-url https://seu-app.com

python cli.py list-tenants --app-url https://seu-app.com
python cli.py set-status --slug cantina-bella --status bloqueado
python cli.py adopt-legacy --slug cantina-bella`;

function Block({ title, text, code, testid }) {
  return (
    <Card className="flex flex-col gap-3" data-testid={testid}>
      <div className="h3">{title}</div>
      <p className="caption">{text}</p>
      <pre className="rounded-xl p-4 text-xs overflow-x-auto" style={{ background: "#1C1C1A", color: "#ECECE7" }}>{code}</pre>
    </Card>
  );
}

export default function Automation() {
  return (
    <Page>
      <PageHeader title="Automação de provisionamento" subtitle="Crie clientes a partir do seu site de vendas, n8n, Zapier ou do terminal" />
      <div className="flex flex-col gap-5 max-w-4xl">
        <Block testid="automation-api" title="API interna" code={API_EXAMPLE}
          text="POST /api/provision cria o cliente completo e responde com o link de acesso, o e-mail e a senha gerada do administrador. A chave fica na variável PROVISION_API_KEY do servidor · nunca a coloque no navegador." />
        <Block testid="automation-cli" title="Linha de comando (servidor próprio)" code={CLI_EXAMPLE}
          text="Para quem hospeda a plataforma: os mesmos passos pelo terminal, usando o banco configurado em backend/.env." />
        <Card className="flex flex-col gap-2" data-testid="automation-domains">
          <div className="h3">Subdomínios e domínios próprios</div>
          <p className="caption">Defina TENANT_BASE_DOMAIN (ex.: cmvapp.com.br) no servidor e aponte um DNS curinga *.cmvapp.com.br para o app: cada cliente abre em identificador.cmvapp.com.br. Domínios próprios cadastrados no cliente também são reconhecidos. Sem domínio configurado, o acesso é pelo link /c/identificador.</p>
        </Card>
      </div>
    </Page>
  );
}
